module.exports = __webpack_public_path__ + "img/PickDashboardMobileApp.35564890.jpg";